var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFaceBookIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.2969 21V12.8H16.0969L16.5969 9.6H13.3969V7.6C13.3969 6.7 13.6969 6.1 14.9969 6.1H16.6969V3.1C16.3969 3.1 15.3969 3 14.2969 3C11.8969 3 10.1969 4.5 10.1969 7.2V9.5H7.29688V12.7H10.0969V21H13.2969Z",
    fill: "#4B2B5A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFaceBookIcon);
export default __webpack_public_path__ + "static/media/faceBookIcon.de480a3bd0353e8169fcc105df77eb4d.svg";
export { ForwardRef as ReactComponent };